import Modal from 'react-bootstrap/Modal';


export function CustomModal(props) {
    return (

        <Modal
            {...props}
            size={props?.size}
            aria-labelledby="contained-modal-title-vcenter"
            className='custom_modal'
            centered
        >
            <Modal.Header closeButton className='custom_modalheader py-2'>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h5 className='mb-0 text-center'>{props?.modaltitle}</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='custom_modalbody'>
                {props?.modalbody()}
            </Modal.Body>
            {props?.modalfooter &&
                <Modal.Footer className='modalfooter'>
                    {props?.modalfooter}
                </Modal.Footer>
            }
        </Modal>


    );
}